import StylingFields from './StylingFields'

export default StylingFields
